import type { editions as en } from '@/i18n/locales/en/editions';
import type { Translation } from '@/i18n/types';

export const editions: Translation<typeof en> = {
  fit: {
    sections: {
      home: 'Αρχική',
      insights: 'Στοιχεία',
      programs: 'Προγράμματα',
      content: 'Περιεχόμενο',
    },
    items: {
      overview: 'Επισκόπηση',
      departments: 'Τμήματα',
      users: 'Χρήστες',
      vitality: 'Ζωτικότητα',
      participation: 'Συμμετοχή',
      pilots: 'Πιλοτικά',
      challenges: 'Προκλήσεις',
      communications: 'Επικοινωνία',
      documents: 'Έγγραφα',
      reports: 'Αναφορές',
      settings: 'Ρυθμίσεις',
    },
  },
  soccer: {
    sections: {
      home: 'Αρχική',
      insights: 'Στοιχεία',
      programs: 'Προγράμματα',
    },
    items: {
      overview: 'Επισκόπηση',
      departments: 'Ομάδες',
      users: 'Παίκτες',
      vitality: 'Ζωτικότητα',
      participation: 'Συμμετοχή',
      pilots: 'Πιλοτικά',
      challenges: 'Προκλήσεις',
    },
  },
};
